//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/TaggedObject.js";
let d=[[],[[["objectTag"],"InitFromObject",{},1,0],[["attrNames","attrValues"],"UpdateAttributes",{},2,0],[["index","attrName","attrValue"],"SetAttribute",{},3,0],[["roomPurpose"],"SetRoomPurpose",{},1,0],[["roomSubPurpose"],"SetRoomSubPurpose",{},1,0],[["objs"],"InitializeFromMultipleObjects",{},1,0],[["row","roomPurpose","roomSubPurpose"],"EditItem",{},3,0],[["row","headString","value"],"UpdateAttributeValue",{},3,0],[["rowIndex"],"UpdateEvaluatdValue",{R_:{needUpdateList:''}},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.ShipDesign.RoomAttributeListBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.RoomAttributeListBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;